import { useRef, useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { useMobileOrientation, isMobileOnly } from 'react-device-detect';
import { Layout } from 'antd';
import { setSizeChangerList, setInitialData, setLoading, setError, setMainContentRef, setCreativeViewSize } from 'context/actions';
import { useAppState, useAppDispatch } from 'context';
import { useRequest, UseRequestType } from 'hooks';
import { buildCreativeSizes } from 'services/utils';
import BannerMenu from 'components/atoms/BannerMenu';
import config from 'config';
import Sidebar from 'components/molecules/Sidebar/Sidebar';
import AppHeader from 'components/molecules/AppHeader';
import ContentFrame from 'components/molecules/ContentFrame';
import MetaTags from 'components/atoms/MetaTags';

import './AppLayout.scss';

const { Header, Content } = Layout;

const AppLayout = () =>{
  const { screenSizeClass, creative, showBannerOptions } = useAppState();
  const { isLandscape } = useMobileOrientation(); // TODO: maybe similar to screenSizeClass
  const dispatch = useAppDispatch();
  const { creative_id: creativeId} = useParams();
  const mainContent = useRef<HTMLDivElement>(null);
  const [url, setUrl] = useState<string>('');
  const { result, loading, error }: UseRequestType = useRequest(url);

  useEffect(() => {
    setUrl(`${config.api.root}/creatives/${creativeId}/player?cb=${Date.now().toString()}`)
  }, [creativeId]);

  useEffect(() => {
    dispatch(setMainContentRef(mainContent.current))
  }, [mainContent.current])

  useEffect(() => {
    dispatch(setLoading(loading));
  }, [loading]);

  useEffect(() => {
    if (error) {
      dispatch(setError(error));
    }
  }, [error]);

  useEffect(() => {
    if (result.data) {
      if(!isMobileOnly) {
        const dropdown =  buildCreativeSizes(result.data)
        dispatch(setSizeChangerList(dropdown)); // save size options
        dispatch(setCreativeViewSize(dropdown[2].size)) // default size
      } else { // most mobile views will be 100% except for banners, so modify in lower components
        dispatch(setCreativeViewSize({width: '100%', height: '100%'}))
      }
      dispatch(setInitialData(result.data)); // set creative
    }
  }, [result.data]);

  return (
    <div className={`app-container ${screenSizeClass}`}>
      {creative?.id && <MetaTags creative={creative} />}
      <Layout>
        <Sidebar />
        <Layout className='app-container__main'>
          <Header className={`app-container__main__header ${isLandscape ? 'landscape' : ''} ${isMobileOnly ? 'mobile' : ''}`}>
            <AppHeader />
          </Header>
          <Content className={`app-container__main__body ${isLandscape ? 'landscape' : ''} ${isMobileOnly ? 'mobile' : ''}`} ref={mainContent}>
            {showBannerOptions && <BannerMenu /> }
            <ContentFrame/>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}

export default AppLayout;
